import { useTranslations } from 'next-intl'

export const useTranslation = () => {
  const t = useTranslations()

  const translateWithFallback = (key: string | undefined) => {
    if (!key) {
      return undefined
    }

    const trimmedKey = key.trim()

    if (t.has(trimmedKey)) {
      return t(trimmedKey)
    }

    return trimmedKey
  }

  return [translateWithFallback]
}
